import PropTypes from 'prop-types';
import React from 'react';
import T from 'components/T';
import Panel from '../../../Panels';
import ProLicenseVerificationCertificationResults from './ProLicenseVerificationCertificationResults';
import {
  candidateName,
  isPartnerVerified,
  NOT_VERIFIED,
} from './ProLicenseVerificationHelpers';
import { isEmpty } from '../../../../lib/helpers';

export class ProLicenseVerification extends React.Component {
  render() {
    const { screening, candidate } = this.props;
    if (screening && screening.status !== 'canceled' && !isEmpty(screening)) {
      const verifiedCertifications =
        screening.certifications.filter(isPartnerVerified);

      if (verifiedCertifications.length > 0) {
        return (
          <Panel
            data-testid='pro-license-verification'
            title={<T value='components.Report.ProLicenseVerification.title' />}
            status={screening.status}
          >
            {verifiedCertifications && (
              <ProLicenseVerificationCertificationResults
                certifications={verifiedCertifications}
                candidateName={candidateName(candidate)}
              />
            )}
          </Panel>
        );
      }
    }
    return <div />;
  }
}

ProLicenseVerification.propTypes = {
  screening: PropTypes.object,
  candidate: PropTypes.object,
};

ProLicenseVerification.defaultProps = {
  screening: {},
  candidate: {},
};

export const hasProLicenseVerificationManualEntries = report => {
  return (
    report.professionalLicenseVerifications?.length > 0 &&
    report.professionalLicenseVerifications.some(plv =>
      plv.certifications.some(
        ({ result = {}, results = [] }) =>
          result.verifiedBy === NOT_VERIFIED ||
          (Array.isArray(results) &&
            results.some(r => r.verifiedBy === NOT_VERIFIED)),
      ),
    )
  );
};
